<div class="bmt-profile-authorizations-container">
    @if (fetchingClients()) {
    <rs-loader></rs-loader>
    }
    @if (errorsFetchingClients()) {
    <p class="error">{{errorsFetchingClients()}}</p>
    }
    @if (groupData().length) {
        <table>
            <thead>
                <th>Admin Plan</th>
                <th>Group Name</th>
                <th>Group Id</th>
                <th>Authorizations</th>
            </thead>
            <tbody>
                @for (group of groupData(); track group.planAcronym + ':' + group.specifiedId) {
                <tr>
                    <td>{{group.planAcronym}}</td>
                    <td>{{group.name}}</td>
                    <td>{{group.specifiedId}}</td>
                    <td><button type="button" class="authorization-link" (click)="openSubGroupAuths(group)">View Subgroup Authorizations</button></td>
                </tr>
                }
            </tbody>
        </table>
    }
    <rs-paginator [length]="totalRecords()" [showFirstLastButtons]="1"
                        (page)="getMoreClients($event)"
                        [pageSize]="defaultPageSize"></rs-paginator>
    @if (selectedClient() && groupSelected()) {
        <rs-dialog maxWidth="80%" [visible]="true" (visibleChange)="closeSubGroupAuths()" heading="Subgroup Authorizations">
            <div class="sub-group-auths">
                <bmt-view-auth-at-group [userContext]="selectedAdminPlan()+'/'+groupSelected()?.planAcronym+'/'+selectedClient()"></bmt-view-auth-at-group>
            </div>
        </rs-dialog>
    }
</div>
